import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorModalComponent } from '../../core/modals/error-modal/error-modal.component';
import { ProfileDetailComponent } from '../../pages/people/person/profile-detail.component';
import { EnrollmentsService } from '../../services/enrollments.service';

@Component({
    selector: 'conflict',
    templateUrl: './conflict.component.html',
    styleUrls: ['./conflict.component.scss'],
    standalone: false
})
export class ConflictComponent implements OnInit{
    @Input() enrollment: any;
    @Input() instructors: any[];
    public isWaitlistRunning: any[] = [];
    @Output() isDropped = new EventEmitter<boolean>();  //  Used for My Courses modal to close window when section is successfully dropped

    constructor(
        public enrollmentService: EnrollmentsService,
        private modalService: NgbModal) { }

    ngOnInit() { }

    public openProfile(openedInstructor) {
        const modalRef = this.modalService.open(ProfileDetailComponent);
        modalRef.componentInstance.person = openedInstructor;
        modalRef.componentInstance.searchterm = "";
    }

    private drop(section, buttonType) {
        this.enrollmentService.confirmDrop(section, buttonType, this.isDropped);
    }

    private updateWaitlist(sectionId, conflict) {
        this.isWaitlistRunning[sectionId + "-" + conflict.SectionId] = true;

        //  Finite observable, no need to unsubscribe
        this.enrollmentService.updateWaitlist(sectionId, conflict.SectionId, conflict.IsDroppable).pipe().subscribe(
            (data) => {
                if (data)
                    conflict.IsDroppable = !conflict.IsDroppable;
                else
                    this.modalService.open(ErrorModalComponent);

                this.isWaitlistRunning[sectionId + "-" + conflict.SectionId] = false;
            }
        );
    }
}
